export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask Kripto",
            h1B: "Bank Kripto MetaMask",
            h1C: "Dompet DeFi Kripto",
            h1D: "Bank Kripto Coinbase",
            h1E: "Bank Tabungan MetaMask",
            h1F: "Betterment",
            h2: "Undang Teman",
            h3: "Tautkan Akun Penarikan",
            h4: "Ikut Menabung",
            h4B: "Deposit Kripto",
            h4C: "Isi Ulang Mata Uang Digital",
            h5: "Investasi Pilihan",
            h5B: "Perdagangan Kontrak Cepat",
            h5c: "Masukkan",
            h6: "Kolam Pengguna",
            h7: "Akun USDT",
            h8: "Total Produksi",
            h9: "Node Valid",
            h10: "Peserta",
            h11: "Pendapatan",
            h12: "Riwayat Pendapatan",
            h13: "Alamat",
            h14: "Nomor",
            h15: "Pertanyaan Umum",
            h16: "Bagaimana cara ikut?",
            h17: "Pengguna yang terhormat, jika Anda ingin ikut menabung di dompet USDT, Anda harus mematuhi aturan platform, mengikuti keputusan platform, dan menerima pengawasan departemen risiko. Anda akan secara otomatis mendapatkan hak menyetor. Selamat bergabung, terima kasih.",
            h17B: "Pengguna yang terhormat, jika Anda ingin ikut menabung di dompet USDT, Anda harus mematuhi aturan platform, mengikuti keputusan platform, dan menerima pengawasan departemen risiko. Anda akan secara otomatis mendapatkan hak menyetor. Selamat bergabung, terima kasih.",
            h18: "Bagaimana cara menarik dana?",
            h19: "Pendapatan harian akan otomatis masuk ke saldo akun. Setelah penarikan USDT berhasil, dana akan otomatis masuk ke akun dompet USDT Anda. Jika ingin menarik Yen, silakan hubungi pusat layanan pelanggan. Terima kasih atas partisipasi dan dukungan Anda.",
            h19B: "Pendapatan harian akan otomatis masuk ke saldo akun. Setelah penarikan USDT berhasil, dana akan otomatis masuk ke akun dompet USDT Anda. Jika ingin menggunakan metode penarikan lain, silakan hubungi layanan pelanggan online!",
            h20: "Bagaimana perhitungan pendapatan?",
            h21B: "Membeli dalam siklus, keuntungan berbeda sesuai tingkat VIP\nVIP1  100u~5000u, bunga: 1.8%\nVIP2  5000u~20000u, bunga: 2.6%\nVIP3  20000u~50000u, bunga: 3.5%\nVIP4  50000u~80000u, bunga: 4.7%\nVIP5  80000u~120000u, bunga: 5.3%\nVIP6  120000u~160000u, bunga: 6.2%\nVIP7  160000u~200000u, bunga: 7.3%\nVIP8  Lebih dari 200000u, bunga: 8%\n\n",
            h21: "Setelah berhasil bergabung, kontrak tabungan akan mulai menghitung pendapatan.",
            h22: "Darimana asal pendapatan tabungan?",
            h23: "Setelah pengguna ikut menabung, kontrak tabungan mulai berlaku. Bunga dihitung dua kali sehari pada pukul 00:00 dan 12:00. Setelah kontrak berlaku, dana masuk ke mode kustodian, platform bertanggung jawab atas keamanan dana. Untuk keamanan akun, patuhi aturan platform. Jika ada masalah, hubungi layanan pelanggan online.",
            h23B: "Setelah pengguna ikut menabung, kontrak tabungan mulai berlaku. Bunga dihitung dua kali sehari pada pukul 00:00 dan 12:00. Setelah kontrak berlaku, dana masuk ke mode kustodian, platform bertanggung jawab atas keamanan dana. Untuk keamanan akun, patuhi aturan platform. Jika ada masalah, hubungi layanan pelanggan online.",
            h24: "Berapa bonusnya?",
            h25: "Anda dapat membagikan platform saya ke teman. Setelah teman bergabung, Anda akan menerima 20% bonus dari setoran pertama mereka dan 10% komisi dari penghasilan mereka secara permanen. Tautan berbagi berada di pojok kanan atas halaman utama.",
            h25B: "Anda dapat membagikan platform ke teman. Setelah teman bergabung, Anda akan menerima 20% bonus dari setoran pertama mereka dan 10% komisi dari penghasilan mereka secara permanen. Tautan berbagi berada di pojok kanan atas halaman utama.",
            h26: "Saldo Tersedia",
            h27: "Jumlah Setoran",
        
            h88: "Latar Belakang Platform",
            h89: "Betterment\nDidirikan: 2008\nKantor Pusat: New York, AS\nPosisi: Robo-Advisor & FinTech, menyediakan pengelolaan portofolio otomatis dan manajemen kas\nRegulator: Diawasi oleh SEC, anggota FINRA\nSkala pelanggan: Mengelola aset lebih dari 40 miliar USD\nPelanggan: Lebih dari 800.000 individu dan bisnis",
            h90: "Keunggulan Platform",
            h91: "✔️ Robo-Advisor pertama di AS, pengalaman matang\n✔️ Portofolio berdasarkan Teori Alokasi Aset Modern (MPT), diversifikasi risiko\n✔️ Menyediakan fungsi optimasi pajak\n✔️ Akun kas bunga tinggi, likuiditas tinggi\n✔️ Operasi sepenuhnya digital, antarmuka sederhana",
            h92: "Cocok untuk",
            h93: "★ Pengguna yang ingin investasi stabil jangka panjang, tidak ingin sering melakukan transaksi\n★ Investor muda yang butuh manajemen otomatis, hemat waktu\n★ Orang dengan kombinasi investasi + tabungan bunga tinggi + akun pensiun\n★ Investor biasa yang ingin memasuki pasar finansial dengan biaya rendah",
        
            h28: "Pendapatan Hari Ini",
            h29: "Total Pendapatan",
            h30: "Tarik Dana",
            h31: "Riwayat",
            h32: "Saldo Tersedia",
            h33: "Jumlah Penarikan",
            h34: "Silakan masukkan jumlah penarikan",
            h35: "Semua",
            h36: "Tarik Dana",
            h37: "Pertanyaan Umum",
            h38: "Ada Laporan Audit Keamanan",
            h39: "Mitra",
            h40: "Mitra Bisnis Kami",
            h41: "Tampilkan Nomor Kartu Bank",
            h42: "Halaman Sebelumnya",
            h43: "Halaman Berikutnya",
            h44: "Ini adalah halaman pertama",
            h45: "Silakan masukkan jumlah penarikan",
            h46: "Saldo tidak cukup",
            h47: "Ini adalah halaman terakhir",
            h48: "Pendapatan",
            h49: "Pengeluaran",
            h50: "Operasi terlalu cepat, silakan coba lagi nanti.",
            h51: "Laporan Audit",
            h52: "Menabung dengan Kripto",
            h521: "Menabung dengan Deposit",
            h53: "Transaksi Pesanan",
            h54: "Bonus Registrasi",
            h55: "Bonus Undangan",
            h56: "Tarik Dana",
            h57: "Isi Ulang",
            h58: "Deposit",
            h59: "Penarikan",
            h591: "Setoran Berhasil",
            h592: "Setoran Gagal",
            h593: "Saldo Tidak Cukup",
            h60: "Berikan USDT melalui transfer kripto",
            h61: "Terima kasih telah mendukung Bank MetaMask. Untuk memudahkan menabung, gunakan kripto (USDT ETH BTC) untuk transfer dan dapatkan bonus tabungan. Tabungan >1000 USDT mendapat 30 USDT, >5000 USDT mendapat 200 USDT, >10000 USDT mendapat 5% setiap kali deposit. (Penarikan dengan dompet kripto juga mendapatkan bonus)",
            h61B: "Terima kasih telah mendukung Bank Coinbase. Gunakan kripto (USDT ETH BTC) untuk transfer dan dapatkan bonus tabungan. Tabungan >1000 USDT mendapat 30 USDT, >5000 USDT mendapat 200 USDT, >10000 USDT mendapat 5% setiap kali deposit.",
            h61C: "Terima kasih telah mendukung Bank MetaMask. Gunakan kripto (USDT ETH BTC) untuk transfer dan dapatkan bonus tabungan. Tabungan >1000 USDT mendapat 30 USDT, >5000 USDT mendapat 200 USDT, >10000 USDT mendapat 5% setiap kali deposit.",
            h61D: "Terima kasih telah mendukung Betterment. Gunakan kripto (USDT ETH BTC) untuk transfer dan dapatkan bonus tabungan. Tabungan >1000 USDT mendapat 30 USDT, >5000 USDT mendapat 200 USDT, >10000 USDT mendapat 5% setiap kali deposit.",
            h62: "Jumlah penarikan Anda adalah {amount}, biaya adalah {fee}%!",
            h63: "Konfirmasi",
            h99: "Segera Dibuka",
        },
        bankcard: {
            b1: "Akun Bank",
            b2: "Nama Institusi Keuangan",
            b3: "Silakan masukkan nama institusi keuangan",
            b4: "Nama Cabang",
            b5: "Silakan masukkan nama cabang",
            b6: "Nomor Cabang",
            b7: "Silakan masukkan nomor cabang",
            b8: "Nomor Akun (Reguler)",
            b9: "Silakan masukkan nomor akun",
            b10: "Nama Palsu",
            b11: "Silakan masukkan nama pengguna",
            b12: "Nama Pemilik Akun",
            b13: "Silakan masukkan nama pemilik akun",
            b14: "Tautkan",
            b15: "Alamat Kripto",
            b16: "Silakan masukkan alamat kripto",
        },
        usdt: {
            u1: "Pesanan Saya",
            u2: "Masukkan",
            u3: "Silakan pilih durasi kontrak:",
            u4: "Harga Beli:",
            u5: "Silakan masukkan jumlah deposit",
            u6: "Tambahkan Beli",
            u7: "Kurangi Beli",
            u8: "Berhasil",
            u9: "Setidaknya sedikit"
        },
        order: {
            o0: "Pesanan Saya",
            o1: "Nomor Pesanan",
            o2: "Jenis Pesanan",
            o3: "Jumlah Beli",
            o4: "Jumlah Jual",
            o5: "Jumlah Bayar",
            o6: "Durasi Kontrak",
            o7: "Status Pesanan",
            o8: "Status Penyelesaian",
            o9: "Waktu Penyelesaian",
            o10: "Waktu Pesan",
            o11: "Tambahkan Beli",
            o12: "Kurangi Beli",
            o13: "Sudah Dijual",
            o14: "Keuntungan",
            o15: "Kerugian",
            o16: "Sudah Dibayar",
            o17: "Titik Impas"
        },
        recharge: {
            r1: "Jumlah Isi Ulang",
            r2: "Jumlah Isi Ulang",
            r3: "Jenis Isi Ulang",
            r4: "Silakan Pilih",
            r5: "Alamat Isi Ulang",
            r6: "Nomor Pesanan Transfer",
            r7: "Sudah Transfer",
            r8: "Sedang Diperiksa",
            r9: "Input Salah",
            r10: "Silakan pilih metode pembayaran",
            r11: "Jumlah isi ulang minimum",
            r12: "Jumlah isi ulang maksimum",
            r13: "Silakan masukkan jumlah",
            r14: "Unggah bukti pembayaran",
            r15: "Silakan unggah bukti pembayaran",
            r16: "Berhasil Dikirim",
            r17: "Batal",
            r18: "Konfirmasi",
        },
        rechargeDetails: {
            r1: "Riwayat Isi Ulang",
            r2: "Jumlah Isi Ulang",
            r3: "Sedang Diperiksa",
            r4: "Isi Ulang Berhasil",
            r5: "Isi Ulang Gagal"
        },
		cert: {
		    c1: "Verifikasi identitas",
		    c2: "Nama asli",
		    c21: "Silakan masukkan nama asli Anda",
		    c3: "Jenis verifikasi",
		    c31: "Kartu identitas",
		    c32: "Paspor",
		    c33: "SIM (Surat Izin Mengemudi)",
		    c10: "Masukkan jenis verifikasi",
		    c4: "Bagian depan dokumen",
		    c41: "Silakan unggah bagian depan dokumen",
		    c5: "Bagian belakang dokumen",
		    c51: "Silakan unggah bagian belakang dokumen",
		    c6: "Kirim",
		    c7: "Berhasil dikirim, menunggu peninjauan...",
		    c8: "Verifikasi berhasil",
		    c9: "Verifikasi identitas gagal, silakan unggah ulang",
		    c11: "Sedang ditinjau",
		    "传入字段不完整": "Kolom input tidak lengkap",
		    "已认证过": "Sudah diverifikasi",
		    "审核中": "Sedang ditinjau"
		}
		 }